import { API_ENDPOINTS } from '../constants';
import { User, LoginCredentials, RegisterData, UserRole } from '../types';

import { get, post, postForm } from './apiClient';

// API response types based on backend structure
export interface LoginResponse {
  access_token: string;
  token_type: string;
  user_info: {
    id: number;
    username: string;
    email: string;
    full_name: string;
    role: string;
    district_id: number;
    school_id: number;
    is_superuser: boolean;
  };
}

export interface RegisterResponse {
  id: number;
  username: string;
  email: string;
  full_name: string;
  is_active: boolean;
  role: UserRole;
  district_id: number;
  school_id: number;
  employee_id: string | null;
  department: string | null;
}

// interface ApiErrorResponse {
//   detail: string;
// }

// Auth service functions
export const login = async (
  credentials: LoginCredentials
): Promise<LoginResponse> => {
  const response = await postForm<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, {
    username: credentials.email,
    password: credentials.password,
  });

  return response;
};

export const register = async (
  data: RegisterData
): Promise<RegisterResponse> => {
  const response = await post<RegisterResponse>(API_ENDPOINTS.AUTH.REGISTER, {
    username: data.email,
    email: data.email,
    full_name: data.full_name,
    password: data.password,
    district_id: data.district_id,
    school_id: data.school_id,
  });

  return response;
};

export const getCurrentUser = async (): Promise<User> => {
  return get<User>(API_ENDPOINTS.AUTH.ME);
};

export const logout = async (): Promise<{ message?: string }> => {
  // Just clear local state - backend logout is optional
  return Promise.resolve({ message: undefined });
};
